export enum InternalErrorCode {
  InvalidAccountSlug,
  InvalidAccountName,
  InvalidSmartLinkSlug,
  InvalidStatsSlug,
  AccountNameIsTaken,
  /** Retired 2026-10-03 with the account social links. Keep the slot: the codes are numbers. */
  SocialLinkExists,
  MainSmartLinkCouldNotBeDeleted,
  AppUpdateRequired,
  SmartLinkSlugIsTaken,
  InvalidOperation,
  EmailTaken,
  NoUserForRapidApiSecret,
  InvalidReturnUrl,
  InvalidCredentials,
  IntegrationUserNotAuthenticated,
  NotSupportedMethod,
  ExternalProviderError,
  UnknownError,
  ItemAlreadyExistsInCollection,
  CollectionDoesNotExists,
  ManualLoginRequired,
  ActionInMusicServiceRequired,
  AccountIsBanned,
  CaptchaFailed,
  /**
   * A pre-save subscribe quoted a streaming-service auth run we did not start,
   * or one that was already spent. The public page maps exactly this code to
   * "you are already saved", because the common cause is a reload of the page
   * the service returned the fan to.
   *
   * Pinned rather than implicit: sml-preview cannot depend on fym-common, so it
   * mirrors this number in
   * `sml-preview/app/src/containers/smartLinks/widgets/presave/presaveApi.ts`.
   * Inserting a member above this one must not move it.
   */
  PresaveAuthAlreadyUsed = 24,
  /**
   * The bio link cannot be taken offline: the public account route serves it
   * for the account's own address, and that address has no other page to fall
   * back to.
   */
  MainSmartLinkCouldNotBeUnpublished,
  /**
   * A free or trial account tried to publish a page whose text or links match
   * the moderation list. The page stays a draft.
   */
  SmartLinkModerationBlocked,
  /**
   * A Promote post goes to a platform that cannot post text only (Instagram,
   * TikTok, YouTube) and carries no media, or the wrong kind of media. The
   * error `details` holds the platforms, comma-separated. Nothing is created.
   *
   * Pinned: the native Music24 apps match this number (and, since 2026-10-05, the string
   * `cause.code` `PromoPostNeedsMedia`). Inserting a member above this one must not move it.
   */
  PromoPostNeedsMedia = 27,
  /**
   * The one-tap artist opt-in after a pre-save sign-up quoted a bad or expired
   * token, or a token of another campaign. The public page asks the fan to
   * pre-save again.
   *
   * Pinned: the clients match it (sml-preview mirrors the number, like
   * `PresaveAuthAlreadyUsed`). Inserting a member above this one must not move it.
   */
  PresaveOptInInvalid = 28,
  /**
   * MusicAPI switched off the API of this partner: an unpaid card invoice, a cancelled plan or
   * an owner action. The `details` field holds the reason. Pinned: partners match the number.
   */
  AccountSuspended = 29,
}
